import * as yup from 'yup'

export const service = yup.object().shape({
  descripcion: yup.string().required('La descripción es obligatorio'),
  tipoRopaId: yup.string().required('El tipo de ropa es obligatorio'),
  tipoAdministracion: yup.string().required('El tipo de administrador es obligatorio'),
  tipoOrdenLavadoId: yup.string().required('El tipo de orden es obligatorio'),
})
